import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { BZ2_EDIT_SUBMIT_HELP, CANCEL, DELETE, DELETION_ENTER_REASON } from 'mk/autogenerated/translations/DeletionForm.7b263627fb6673157e4edcbc148b087a'
import { InputField } from 'mk2/components/forms/InputField';
import { SubmitButton } from 'mk2/components/forms/SubmitButton';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Form } from 'mk2/components/Form';
import { mkReduxForm, MKReduxFormInjectedProps } from 'mk2/decorators/mkReduxForm';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import { FormErrors } from 'redux-form';
import { TITLES } from './Deletion.constants';
import styles from './DeletionForm.mscss';

export interface DeletionFormData {
    deletionComment: string;
}

interface OwnProps {
    className?: string;
    entity: string;
    id: number;
    scrollOffset?: number; // When deletion is displayed we are scrolling it into view - this can be used to add some offset

    onExecute(entity: string, id: number, fd: DeletionFormData);
    onCancel(entity: string, id: number);
}

type Props = OwnProps;

class DeletionFormComponent extends React.Component<Props & MKReduxFormInjectedProps<DeletionFormData, Props>> {

    public static validate(values: DeletionFormData): FormErrors<DeletionFormData> {
        const errors: FormErrors<DeletionFormData> = {};
        if (!values.deletionComment) {
            errors.deletionComment = BZ2_EDIT_SUBMIT_HELP;
        }
        return errors;
    }

    private container: HTMLDivElement;

    public componentDidMount() {
        const rect = this.container.getBoundingClientRect();
        // Detect if the container is in the viewport
        if (rect.top < 0 || rect.bottom > (window.innerHeight || document.documentElement.clientHeight)) {
            // Scroll to viewport
            this.container.scrollIntoView(true);
            if (this.props.scrollOffset && window.scrollY) {
                window.scroll(0, window.scrollY - this.props.scrollOffset);
            }
        }
    }

    public render() {
        const { className, entity, form, handleSubmit } = this.props;

        const title = interpolate(TITLES[entity]);

        return (
            <div className={cx(styles.DeletionForm, className)} ref={(r) => this.container = r}>
                <div className={styles.DeletionForm__title}>
                    <FontAwesomeIcon icon={faExclamationTriangle} /> {title}
                </div>

                <Form className={styles.DeletionForm__form} onSubmit={handleSubmit}>
                    <InputField
                        name="deletionComment"
                        label={DELETION_ENTER_REASON}
                        type="text"
                        autoFocus
                        marginLeft={false}
                    />

                    <div className={styles.DeletionForm__form__buttons}>
                        <SubmitButton
                            key="execute"
                            label={DELETE}
                            formName={form}
                        />
                        <Btn
                            key="cancel"
                            type={BtnType.Link}
                            label={CANCEL}
                            onClick={this.handleOnCancel}
                        />
                    </div>
                </Form>
            </div>
        );
    }

    private handleOnCancel = () => {
        const { onCancel, entity, id } = this.props;
        onCancel(entity, id);
    };
}

export const DeletionFormFactory = (formName: string) => mkReduxForm<DeletionFormData, Props>({
    formName,
    onValidate: (values) => DeletionFormComponent.validate(values),
    onSave: (values, props) => props.onExecute(props.entity, props.id, values),
})(DeletionFormComponent);
